import apiFetch from '../apiFetch'

export default function (saleId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Sale/${saleId}/SendToDms`, method: 'PUT', body: null, token: token, lastAccessDate })
}
